import { toast } from "react-toastify";
import { _TechnicianAssignment } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE } from "../../../../theme/Component/BasicTable";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { useEffect } from "react";
import { tr } from "date-fns/locale";
import usePaginator from "../../../../theme/Component/usePaginator";

interface Props {
    _Technician: any;
}

export const TechnicianAssignment = ({ _Technician }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_TechnicianAssignment);
    const paginador = usePaginator();

    useEffect(() => {
        if (_Technician) {
            getLista();
        }
    }, [_Technician])

    const getLista = () => {
        const props = {
            IDTechnician: _Technician.IDTechnicians,
            State: 1,
        }
        instance.getTechnicianAssignmentRender(paginador.page, 15, props, null, null).then(
            (resp) => {
                resp.List.forEach(asigned => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    if (!asigned.DataBeanProperties) {
                        asigned.DataBeanProperties = {};
                    }
                    const asignation = asigned.DataBeanProperties;

                    asignation.Start = `${asignation.StartHour ? `${pad(asignation.StartHour ?? 0)}:${pad(asignation.StartMinute ?? 0)}` : "N/P"}`;
                    asignation.End = `${asignation.EndHour ? `${pad(asignation.EndHour ?? 0)}:${pad(asignation.EndMinute ?? 0)}` : "N/P"}`;
                });
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setBean({});
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTechnicianAssignment', visible: true },
        { title: 'Fecha de Mantenimiento', property: 'AssignmentDate', visible: true, mask: MASK_DATE },
        { title: 'Desde', property: 'Start', visible: true },
        { title: 'Hasta', property: 'End', visible: true },
        { title: 'Maquina', property: 'FixedAssetDescription', visible: true },
        { title: 'Codigo del Mantenimiento', property: 'AlphaCode', visible: false },
    ];


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />
            </div>
        </div>
    )
}